import React from 'react';
import { string } from 'prop-types';

const IconSledging = props => {
  const { className } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 20 20">
      <path d="M8.25,3.75C8.25,2.78,9.03,2,10,2s1.75,0.78,1.75,1.75S10.97,5.5,10,5.5S8.25,4.72,8.25,3.75z M18.85,16.93 c-0.51,1.58-2.21,2.44-3.78,1.93L1,14.28l0.31-0.95l3.13,1.02l0.46-1.43L1.77,11.9l0.31-0.95l1.42,0.46V8l4.4-1.87 c0.32-0.14,0.68-0.17,1.04-0.06c0.79,0.24,1.24,1.08,1,1.87L9.15,10.5l2.09-0.37c0.45-0.08,0.89,0.16,1.08,0.57l1.92,4.2l1.92,0.62 l-0.31,0.95l-2.85-0.93l-0.46,1.43l2.85,0.93c1.05,0.34,2.18-0.24,2.52-1.28c0.34-1.05-0.24-2.18-1.28-2.52l0.31-0.95 C18.5,13.66,19.36,15.35,18.85,16.93z M5,11.9l1.17,0.38c-0.31-0.38-0.43-0.89-0.28-1.39l0.8-2.62L5,9V11.9z M12.04,15.24 l-6.18-2.01l-0.46,1.43l6.18,2.01L12.04,15.24z M12.3,14.27l-1.12-2.46L7.7,12.78L12.3,14.27z" />
    </svg>
  );
};

IconSledging.defaultProps = { className: null };
IconSledging.propTypes = { className: string };

export default IconSledging;
